import { RotateCcw } from "lucide-react";
import { ModelPicker } from "./model-picker.js";

/**
 * A model that may be inherited — the picker sibling of `InheritedNumberField`,
 * down to the reset button and the label that names where an empty value falls
 * back to. Empty means "inherit"; the label says from where.
 */
export function InheritedModelField({
  value,
  inheritedLabel,
  onChange,
  "aria-label": ariaLabel,
}: {
  value: string | null;
  /** Where an empty value falls back to, named in the reset button's tooltip. */
  inheritedLabel: string;
  onChange: (value: string | null) => void;
  "aria-label": string;
}) {
  return (
    <span className="flex items-center gap-1">
      <ModelPicker className="w-64" value={value ?? ""} onChange={onChange} />
      {/* Same reserved reset slot as InheritedNumberField, so a number row and a
          model row end on the same edge. */}
      <span className="flex h-7 w-7 shrink-0 items-center justify-center">
        {value !== null ? (
          <button
            type="button"
            onClick={() => onChange(null)}
            title={`Auf ${inheritedLabel} zurücksetzen`}
            aria-label={`${ariaLabel} auf ${inheritedLabel} zurücksetzen`}
            className="rounded-full p-1 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
          >
            <RotateCcw className="h-3.5 w-3.5" />
          </button>
        ) : null}
      </span>
    </span>
  );
}
